export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f422009eb3d0be669625afc15786c4a4c25195743&name=fetchTypeahead!'